import styled from 'styled-components';
import Header from '../../../Header';
import backgroundCircle from './backgroundCIrcle.svg';
import { SeparatorBase } from 'components/TrialProposal/TrialProposalSeparator';

export const StyledPlansContainer = styled.div`
  display: flex;
  align-self: center;
  max-width: 1200px;
  margin: 0 auto auto;
  justify-content: space-between;
  
  @media (max-width: 999px) {
    flex-direction: column;
    min-width: auto;
    
    & > * {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const StyledPricingPage = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const StyledH1 = styled(Header)`
  margin: 80px 0 16px;
  padding: 0 24px;
  font-weight: 900;
`;
export const StyledH7 = styled(Header)`
  margin-top: 36px;
`;
export const StyledDesktopWrapper = styled.div`
  @media (max-width: 999px) {
    display: none;
  }
`;

export const StyledPlansSection = styled.div`
  padding: 64px 0;
  background-image: url("${backgroundCircle}");
  background-attachment: fixed;
  background-position: 50% 50%;
  background-size: 140% auto;
  background-repeat: no-repeat;
  background-color: #f9bb40;
  color: white;

  ${SeparatorBase} {
    background-color: white;
  }
  
  ${StyledH1} {
    color: black;
  }
`;
